<template>
  <div class="flexbox-c home">
    <div class="flexbox-c header">
      <div class="menu">
        <Navigator :signin="false" :signup="false" />
      </div>
      <div class="websittitle">MAKE YOUR LIFE MORE INTERESTING</div>
      <div class="flexbox-c loginbox">
        <div style="width: 1000px">
          <img src="~@/assets/images/heart_logo.png" alt="" class="logo" />
          <router-link class="btn" to="/w/home/index" replace>
            {{ $t("home.index") }}
          </router-link>
          <router-link class="btn" to="/w/home/member" replace>
            {{ $t("home.member") }}
          </router-link>
          <router-link class="btn" to="/w/home/chat" replace>
            {{ $t("home.chat") }}
            <el-badge
              :value="unreadmsg"
              class="item"
              type="danger"
              :hidden="unreadmsg <= 0"
            >
              <span
                style="display: inline-block; width: 1px; height: 20px"
              ></span>
            </el-badge>
          </router-link>
          <router-link class="btn" to="/w/home/pay" replace>
            {{ $t("home.recharge") }}
          </router-link>
          <router-link class="btn" to="/w/home/upgrade" replace>
            {{ $t("home.upgrade") }}
          </router-link>
          <router-link class="btn" to="/w/home/store" replace>
            {{ $t("home.store") }}
          </router-link>
        </div>
      </div>
    </div>

    <div class="flexbox-c homecontent alertbox" v-if="userstatus == 2">
      <div class="flexbox alert">
        <i class="iconfont icon-warning"></i>
        <div class="flexbox text">{{ $t("tips.aproval") }}</div>
      </div>
    </div>
    <div class="flexbox-c homecontent" v-else>
      <router-view></router-view>
    </div>

    <div class="footer">
      <Footer />
    </div>
  </div>
  <Report />
  <Service />
  <ChatLIst />
  <GlobalGiftSendWindow />
</template>

<script>
import Footer from "../../components/web/LoginFooter.vue"
import Navigator from "../../components/web/Navigator.vue"
import Service from "../../components/web/Service.vue"
import ChatLIst from "../../components/web/ChatLIst.vue"
import Report from "../../components/web/Report.vue"
import GlobalGiftSendWindow from "../../components/web/GlobalGiftSendWindow.vue"
import "../../assets/css/common.scss"
export default {
  components: {
    Footer,
    Navigator,
    Service,
    ChatLIst,
    Report,
    GlobalGiftSendWindow,
  },
  computed: {
    unreadmsg () {
      return this.$store.state.Chat.count;
    },
    userstatus () {
      return this.$store.state.User.status;
    }
  },
  created () {
    this.$store.dispatch("getStoreList");
    this.$store.dispatch('initWebsocket');
    this.$store.dispatch('getMessage');
    this.$store.dispatch('getNotice');
  }
}
</script>



<style lang="scss" scoped>
.home {
  background-color: #9c6d97;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAYsCAIAAADVmHmEAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAABXJJREFUeNrs3dERgjAMANDWY/8J/HQJV/HXPcQNkAOBJH1M8C4XSpIW6PfHs2W7bi3hBQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDX3ZNbU2izQ0NDQ0NDQ0NDT0UE3ALNLQ0NBbVo8u0tDQ0NDQ0NDQ0NDQ0NDQ0DXRjk5AQ0NDQ0PnfYzbvoCGhoaGhoaGrljlGdZAQ0NrbEUaGhoaGhoaGhoaGhp6wB7Rm5/Q0NDQsdfpbvsCGhoaGhoaGhoaGjpB55IQnXEs5ogbNDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NDQ0NHSwy1Fk6KX08DYzNDQ0NDR0c94DGhoaGhraCAHaCAEaGhoaGhoaen89nbCgVuVBQ0NDQ0NDQ0OHqad9VkB6QENrbKGhoaGhoaGhoRNXeQ5eQUOHuBENa6ChoaGhoaGh9YgirZ6GhoaGhoaGhoaGhoaGhoY2QpAe0NABVw8na06KtKE6NDQ0NDQ0tNpDekBDQ0NDQ0ND76vyzPKgy+W0T4RKD2hoaGhoaOiCVV7Sj5I4eAUNDQ0NDQ0NDQ2tcxFpaOiTu3GvQUFDQ29bPTL+OUftAQ0NDa00FWloaGhonYtIQ0NDQ0ND53iMv94fkYaGhoaG/nOPaAAJDQ29afXwx2DpAQ0NDQ0NrfaQHhpb6QENDQ0NDQ0NfVyV50M70NDQ0NDQ0NDLBZOpKTR0iM5FpKGL5bQ9F2hoaGhonYv0gIZWmkoPaGi1h0ivWKeNxaChoaGhoaGhoaG1WyKt3XIjQkNDQ+d4uCR8uqg9oKGhoaGhoaGhoaEztFt+VCo9jBBEGhoaGhoaGhoaWmkqPaChoaGhoaGh11V55tPQ0NDQ0EYI0gNawQS9Y8nzwhk0NDQ0tHpaekBDQ+sRRRpajwgNDQ0NDa3KE+nKVZ5hDTQ0NDQ0NDQ0NPRgPaJRLzQ0NDQ0NDQ0dJDSVKShoaHHWfIcvIJeSg87ttDQ0NDQ0NDQ0NDQ0Not6QENDQ2d4uFidwu6XMFk+wIaGhoaGhoaGjpIaWqWBw19/Y1o7gFd7uFi7gENDQ0NDQ2tsdUEQENDQ0NDQ0NDQ0NDQ0NDQ0NDF0Cb5UGXy2mnxaChoaGhoaGhoaH1iNDQ0NBV12lzD+il9PCeCzQ0NDQ0NDQ0NDQ0NDQ09O8Rgp0AaGhoaGhoaGhoaGhoaGhoaGhoaGho6HXX1J3Lg4aGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhoaGhj76+gowAB9mS7CMD0b7AAAAAElFTkSuQmCC);
  background-position: left top;
  background-repeat: repeat-x;
}
.header {
  width: 100%;
  height: 500px;
  background-image: url(~@/assets/images/promo2.jpg);
  background-size: cover;
  background-position: center center;
  align-content: space-between;
  .menu {
    width: auto;
    height: auto;
    position: fixed;
    right: 0px;
    top: 0px;
    z-index: 1994;
  }
  .websittitle {
    color: #fff;
    font-size: 50px;
    margin-top: 150px;
    padding-right: 100px;
    font-family: "Times New Roman", Times, serif;
  }
  .loginbox {
    width: 100%;
    min-width: 1000px;
    height: 75px;
    background: rgba(255, 255, 255, 0.3);
    align-self: flex-end;
    padding-top: 20px;
    .logo {
      width: 40px;
      height: 40px;
      margin-right: 60px;
      margin-left: 15px;
    }
    .btn {
      padding-top: 10px;
      padding-right: 20px;
      font-size: 21px;
      color: $themeColor;
    }
    .btn:hover {
      text-decoration: underline;
    }
    .router-link-active {
      text-decoration: underline;
    }
  }
}
.footer {
  width: 100%;
  background-color: #b997ae;
}
.body {
  height: 100%;
  background-image: url(~@/assets/images/bodybg.png);
}
.homecontent {
  width: 1000px;
  min-height: 400px;
}
.alertbox {
  height: 30px;
  font-size: 16px;
  align-items: center;
  padding-top: 50px;
  .alert {
    background-color: rgb(209, 185, 167);
    border-radius: 10px;
    height: 32px;
    flex-wrap: nowrap;
    padding: 0 20px;
    i {
      font-size: 24px;
      flex-shrink: 0;
    }
    .text {
      width: 100%;
    }
  }
}
</style>